import { render, staticRenderFns } from "./CSpinner.vue?vue&type=template&id=5e845ae8&"
import script from "./CSpinner.vue?vue&type=script&lang=js&"
export * from "./CSpinner.vue?vue&type=script&lang=js&"
import style0 from "./CSpinner.vue?vue&type=style&index=0&id=5e845ae8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports